import React from "react";
import { Routes, Route } from "react-router-dom";
import Code from "../pages/Code";
import Dashboard from "../pages/Dashboard";
import EditProfile from "../pages/EditProfile";

function PrivateRoutes() {
  return (
    <Routes>
      <Route path="" element={<Dashboard />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/edit-profile" element={<EditProfile />} />
    </Routes>
  );
}

export default PrivateRoutes;
